import _ from "lodash";
import PaymentMethodService from "../provider/PaymentMethod/PaymentMethodService";
import { SUCCESS } from "../common/Util";
import {
	CHANGE_APP_PROPS,
	CHANGE_PAYMENT_METHOD_PROPS
} from "./ActionConstants";

export function actionGetPaymentMethodList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetPaymentMethodList(searchText, offset, limit).then(response => {
			dispatch({
				type: CHANGE_PAYMENT_METHOD_PROPS,
				props: {
					paymentMethodsList: response,
					total: !_.isEmpty(response) ? response[0].cantidad : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetPaymentMethodList(searchText, offset, limit) {
	return await PaymentMethodService.getPaymentMethodList(
		searchText,
		offset,
		limit
	);
}

export function actionCreatePaymentMethod(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncCreatePaymentMethod(values)
			.then(() => {
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncCreatePaymentMethod(values) {
	return await PaymentMethodService.createPaymentMethod(values);
}

export function actionUpdatePaymentMethod(values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		asyncUpdatePaymentMethod(values)
			.then(response => {
				let paymentMethodsList = store().paymentMethod.paymentMethodsList;
				const paymentMethodIndex = paymentMethodsList.findIndex(e => {
					return e.id === response.id;
				});
				paymentMethodsList[paymentMethodIndex] = response;
				dispatch({
					type: CHANGE_PAYMENT_METHOD_PROPS,
					props: {
						paymentMethod: response,
						paymentMethodsList
					}
				});
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncUpdatePaymentMethod(values) {
	return await PaymentMethodService.updatePaymentMethod(values);
}

export function actionChangePaymentMethodProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_PAYMENT_METHOD_PROPS,
			props: props
		});
	};
}



// WEBPACK FOOTER //
// ./src/actions/PaymentMethodActions.js